export default {
    'en_CA': 'English (Canada)',
    'en_US': 'English (United States)',
    'en_GB': 'English (Great Britain)',
    'fr_CA': 'French (Canada)',
    'fr_FR': 'French (France)',
	'fr_BE': 'French (Belgium)',
	'fr_MA': 'French (Morocco)',
    'pt_PT': 'Portuguese (Portugal)',
	'el_GR': 'Greek (Greece)',
	'es_ES': 'Spanish (Spain)',
	'es_MX': 'Spanish (Mexico)',
	'es_CO': 'Spanish (Colombia)',
	'nl_BE': 'Dutch (Belgium)',
	'pt_BR': 'Portuguese (Brazil)',
	'sk_SK': 'Slovak (Slovakia)',
	'sr_RS': 'Serbian (Serbia)',
	'tr_TR': 'Turkish (Turkey)',
    'fi_FI': 'Finnish (Finland)',
    'sv_SE': 'Swedish (Sweden)',
    "WIN_DRAW_WIN": "Matchresultaat",
    "CORRECT_SCORE": "Correcte score",
    "TOTAL_GOALS": "Totaal aantal doelpunten",
    "DOUBLE_CHANCE": "Dubbele kans",
    "UNDER_OVER": "Meer dan/Minder dan",
    "UNDER_OVER_25": "Meer dan/Minder dan 2.5",
    "UNDER_OVER_25_INITIALS": "O/U 2.5",
    "UNDER_OVER_35_INITIALS": "O/U 3.5",
    "UNDER_OVER_15": "Meer dan/Minder dan 1.5",
    "ASIAN_HANDICAP": "Asian Handicap",
    "HANDICAP": "1X2 Handicap",
    "HANDICAP_FIRST": "1X2 Handicap Home +1",
    "HANDICAP_SECOND": "1X2 Handicap Away +1",
    "UNDER_OVER_05": "Minder dan/Meer dan 0.5",
    "UNDER_OVER_35": "Meer dan/Minder dan 3.5",
    "BOTH_TEAMS_SCORE": "Beide teams scoren",
    "BOTH_TEAMS_SCORE_INITIALS": "BTS",
    "HOME_TEAM_GOALS": "{0} teamdoelpunten",
    "AWAY_TEAM_GOALS": "{1} teamdoelpunten",
    "MATCH_BETTING_BOTH_TEAMS_SCORE": "Match Betting Beide teams scoren",
    "WINNING_MARGIN": "Winstmarge",
    "CORRECT_SCORE_GROUP": "Correcte score groep",
    "HOME_TEAM_TO_SCORE": "{0} scoort",
    "AWAY_TEAM_TO_SCORE": "{1} scoort",
    "FIRST_TEAM_TO_SCORE": "Team dat als eerste scoort",
    "LAST_TEAM_TO_SCORE": "Team dat als laatste scoort",
    "HALF_TIME_FULL_TIME": "Rust Reguliere speeltijd",
    "TEAM_SCORECAST": "Team Scorecast",
    "HALF_TIME_CORRECT_SCORE": "Correcte score aan de rust",
    "HALF_TIME_RESULT": "Score aan de rust",
    "FIRST_LAST_TO_SCORE": "First / Last to Score",
    "LAST": "Laatste",
    "FIRST": "Eerste",
    "IN": "In",
    "LAST_THREE_GAMES": "Last 3 Games",
    "PREVIOUS": "Vorige",
    "EIGHT_RESULTS": "8 wedstrijden",
    "EIGHT_GAMES": "8 games",
    "OVER_25": "Meer dan 2.5",
    "UNDER_25": "Minder dan 2.5",
    "OVER_35": "Meer dan 3.5",
    "UNDER_35": "Minder dan 3.5",
    "COVERED": "Bedekt",
    "DID_NOT_COVER": "Dekte niet",
    "SPREAD": "Verschil",
    "TOTAL_POINTS_UNDER_OVER": "Puntentotaal U/O",
    "TOTAL_POINTS_OVER_UNDER": "Puntentotaal O/U",
    "MONEYLINE": "Money Line",
    "TOTAL_POINTS_GROUP": "Totaal aantal punten groep",
    "MONEY_LINE_TOTAL_POINTS": "Money Line & Puntentotaal O/U",
    "SPREAD_TOTAL_POINTS": "Handicap & Puntentotaal O/U",
    "Argentina": "Argentina",
    "Belgium": "Belgium",
    "Brazil": "Brazil",
    "Colombia": "Colombia",
    "Costa Rica": "Costa Rica",
    "Croatia": "Croatia",
    "Czech Republic": "Czech Republic",
    "Denmark": "Denmark",
    "Egypt": "Egypt",
    "England": "England",
    "France": "France",
    "Germany": "Germany",
    "Greece": "Greece",
    "Holland": "Holland",
    "Iceland": "Iceland",
    "Italy": "Italy",
    "Mexico": "Mexico",
    "Poland": "Poland",
    "Portugal": "Portugal",
    "Republic of Ireland": "Republic of Ireland",
    "Russia": "Russia",
    "Spain": "Spain",
    "Sweden": "Sweden",
    "Switzerland": "Switzerland",
    "Ukraine": "Ukraine",
    "Uruguay": "Uruguay",
    "Boston": "Boston",
    "Cleveland": "Cleveland",
    "Houston": "Houston",
    "Los Angeles": "Los Angeles",
    "Orlando": "Orlando",
    "Portland": "Portland",
    "San Antonio": "San Antonio",
    "Euro Arena": "Euro Arena",
    "Athens": "Athens",
    "Real": "Real",
    "Piraeus": "Piraeus",
    "Istanbul Blues": "Istanbul Blues",
    "Fener": "Fener",
    "Vitoria": "Vitoria",
    "Tel Aviv Yellows": "Tel Aviv Yellows",
    "Moscow": "Moscow",
    "Kaunas": "Kaunas",
    "Barcelona City": "Barcelona City",
    "Belgrade": "Belgrade",
    "Lyon": "Lyon",
    "Khimki": "Khimki",
    "Berlin": "Berlin",
    "St Petersburg": "St Petersburg",
    "Valencia": "Valencia",
    "Turkey": "Turkey",
    "Netherlands": "Netherlands",
    "Utd": "United",
    "City": "City",
    "Liverpool": "Liverpool",
    "Barcelona": "Barcelona",
    "Madrid": "Madrid",
    "Munich": "Munich",
    "Turin": "Turin",
    "Milan": "Milan",
    "Amsterdam": "Amsterdam",
    "Paris": "Paris",
    "Pittsburgh": "Pittsburgh",
    "Philadelphia": "Philadelphia",
    "Denver": "Denver",
    "New York": "New York",
    "New England": "New England",
    "Green Bay": "Green Bay",
    "San Francisco": "San Francisco",
    "Miami": "Miami",
    "Dallas": "Dallas",
    "Oakland": "Oakland",
    "Chicago": "Chicago",
    "DRAW": "Gelijkspel",
    "HD": "{0}/Gelijkspel",
    "DA": "Gelijkspel/{1}",
    "HA": "{0}/{1}",
    "Under 2.5": "Minder dan 2.5",
    "Over 2.5": "Meer dan 2.5",
    "Under 1.5": "Minder dan 1.5",
    "Over 1.5": "Meer dan 1.5",
    "Under": "Minder dan {0}",
    "Over": "Meer dan {0}",
    "HOME": "{0}",
    "AWAY": "{1}",
    "Under 0.5": "Minder dan 0.5",
    "Over 0.5": "Meer dan 0.5",
    "Under 3.5": "Minder dan 3.5",
    "Over 3.5": "Meer dan 3.5",
    "Both Score Yes": "Ja",
    "Both Score No": "Neen",
    "Home Not to Score": "{0} Not to Score",
    "Home Exactly 1": "{0} Exactly 1",
    "Home Exactly 2": "{0} Exactly 2",
    "Home Exactly 3": "{0} Exactly 3",
    "Home Exactly 4": "{0} Exactly 4",
    "Away Not to Score": "{1} Not to Score",
    "Away Exactly 1": "{1} Exactly 1",
    "Away Exactly 2": "{1} Exactly 2",
    "Away Exactly 3": "{1} Exactly 3",
    "Away Exactly 4": "{1} Exactly 4",
    "Home to Win and both teams to score": "{0} wint en beide teams scoren",
    "Home to Win to nil": "{0} to Win to nil",
    "Score draw": "Score draw",
    "0-0": "0-0",
    "0-1": "0-1",
    "0-2": "0-2",
    "0-3": "0-3",
    "0-4": "0-4",
    "0-5": "0-5",
    "0-6": "0-6",
    "1-0": "1-0",
    "2-0": "2-0",
    "3-0": "3-0",
    "4-0": "4-0",
    "5-0": "5-0",
    "6-0": "6-0",
    "1-1": "1-1",
    "2-2": "2-2",
    "3-3": "3-3",
    "2-1": "2-1",
    "1-2": "1-2",
    "3-1": "3-1",
    "1-3": "1-3",
    "3-2": "3-2",
    "2-3": "2-3",
    "4-1": "4-1",
    "1-4": "1-4",
    "4-2": "4-2",
    "2-4": "2-4",
    "5-1": "5-1",
    "1-5": "1-5",
    "1-0,2-0,2-1": "1-0,2-0,2-1",
    "3-0,3-1,4-0": "3-0,3-1,4-0",
    "1-1,2-2": "1-1,2-2",
    "0-1,0-2,1-2": "0-1,0-2,1-2",
    "0-3,1-3,0-4": "0-3,1-3,0-4",
    "Away to Win and both teams to score": "{1} wint en beide teams scoren",
    "Away to Win to nil": "{1} wint zonder tegendoelpunt",
    "Home Win By Exactly 1 Goal": "{0} wint met exact 1 doelpunt voorsprong",
    "Home Win By Exactly 2 Goals": "{0} wint met exact 2 doelpunt voorsprong",
    "Home Win By 3 or more goals": "{0} Win By 3 or more goals",
    "Away Win By Exactly 1 Goal": "{1} wint met exact 1 doelpunt voorsprong",
    "Away Win By Exactly 2 Goals": "{1} wint met exact 2 doelpunt voorsprong",
    "Away Win By 3 or more goals": "{1} Win By 3 or more goals",
    "Draw With No Goals": "Gelijkspel zonder doelpunt",
    "Draw With Goals": "Gelijkspel met doelpunten",
    "Any Other": "Eender welke andere",
    "Home Not To Score": "{0} scoort niet",
    "Home To Score": "{0} scoort",
    "Away Not To Score": "{1} scoort niet",
    "Away To Score": "{1} scoort",
    "Home": "{0}",
    "No Goal": "Geen goals",
    "Away": "{1}",
    "Home/Home": "{0}/{0}",
    "Home/Draw": "{0}/Gelijkspel",
    "Home/Away": "{0}/{1}",
    "Draw/Home": "Gelijkspel/{0}",
    "Draw/Draw": "Gelijkspel/Gelijkspel",
    "Draw/Away": "Gelijkspel/{1}",
    "Away/Home": "{1}/{0}",
    "Away/Draw": "{1}/Gelijkspel",
    "Away/Away": "{1}/{1}",
    "Home and 1-0": "{0} en 1-0",
    "Home and 2-0": "{0} en 2-0",
    "Home and 2-1": "{0} en 2-1",
    "Away and 2-1": "{1} en 2-1",
    "Home and 3-0": "{0} en 3-0",
    "Home and 3-1": "{0} en 3-1",
    "Away and 3-1": "{1} en 3-1",
    "Home and 4-0": "{0} en 4-0",
    "Home and 1-1": "{0} en 1-1",
    "Away and 1-1": "{1} en 1-1",
    "Home and 2-2": "{0} en 2-2",
    "Away and 2-2": "{1} en 2-2",
    "Away and 0-1": "{1} en 0-1",
    "Away and 0-2": "{1} en 0-2",
    "Away and 1-2": "{1} en 1-2",
    "Home and 1-2": "{0} en 1-2",
    "Away and 0-3": "{1} en 0-3",
    "Away and 1-3": "{1} en 1-3",
    "Home and 1-3": "{0} en 1-3",
    "Away and 0-4": "{1} en 0-4",
    "Other": "Ander",
    "Draw": "Gelijkspel",
    "120-124": "120-124",
    "125-129": "125-129",
    "130-134": "130-134",
    "135-139": "135-139",
    "140-144": "140-144",
    "145-149": "145-149",
    "150-154": "150-154",
    "155-159": "155-159",
    "160-164": "160-164",
    "165-169": "165-169",
    "170-174": "170-174",
    "175-179": "175-179",
    "Under 180": "Minder dan 180",
    "180-184": "180-184",
    "185-189": "185-189",
    "190-194": "190-194",
    "195-199": "195-199",
    "200-204": "200-204",
    "205-209": "205-209",
    "210-214": "210-214",
    "215-219": "215-219",
    "220-224": "220-224",
    "225-229": "225-229",
    "230-234": "230-234",
    "235-239": "235-239",
    "240-244": "240-244",
    "245-249": "245-249",
    "Over 249": "Meer dan 249",
    "26-30": "26-30",
    "31-35": "31-35",
    "36-40": "36-40",
    "41-45": "41-45",
    "46-50": "46-50",
    "25 And Under": "Minder dan 26",
    "25 And Under Short": "Minder dan 26",
    "51 And Over": "Meer dan 50",
    "51 And Over Short": "Meer dan 50",
    "and": "&",
    "slash": "/",
    "FIRST_PLAY": "1st Play",
    "SECOND_PLAY": "2nd Play",
    "THIRD_PLAY": "3rd Play",
    "FOURTH_PLAY": "4th Play",
    "FIFTH_PLAY": "5th or More Play",
    "FIELD_GOAL": "Field Goal",
    "PassTD on 1st Play": "PassTD on 1st Play",
    "PassTD on 2nd Play": "PassTD on 2nd Play",
    "PassTD on 3rd Play": "PassTD on 3rd Play",
    "PassTD on 4th Play": "PassTD on 4th Play",
    "PassTD on or after 5th Play": "PassTD on or after 5th Play",
    "RunTD on 1st Play": "RunTD on 1st Play",
    "RunTD on 2nd Play": "RunTD on 2nd Play",
    "RunTD on 3rd Play": "RunTD on 3rd Play",
    "RunTD on 4th Play": "RunTD on 4th Play",
    "RunTD on or after 5th Play": "RunTD on or after 5th Play",
    "Turnover on 1st Play": "Turnover on 1st Play",
    "Turnover on 2nd Play": "Turnover on 2nd Play",
    "Turnover on 3rd Play": "Turnover on 3rd Play",
    "Turnover on 4th Play": "Turnover on 4th Play",
    "Turnover on or after 5th Play": "Turnover on or after 5th Play",
    "Field Goal": "Field Goal",
    "US_Football_Football": "Amerikaans",
    "Matchday": "Speeldag",
    "Basketball": "Basketbal",
    "Cycling": "Wielrennen",
    "Horses Jumps": "Horses Jumps",
    "Horses Flats": "Horses Flats",
    "Horses Sprints": "Horses Sprints",
    "Horses Furlong": "Horses Furlong",
    "Horses Trotting": "Horses Trotting",
    "Dogs": "Honden",
    "Greyhounds": "Windhonden",
    "Rush Dogs": "Greyhounds",
    "Motor Racing": "Motorracen",
    "Speedway": "Speedway",
    "Results": "Resultaten",
    "Horses": "Paarden",
    "Motorcycles": "Motorfietsen",
    "Cars": "Auto's",
    "First Down": "1st Down",
    "Formula Racing": "Motorracen",
    "Soccer_Euro": "Euro",
    "Soccer_Soccer3_Super_League": "Super League",
    "Soccer_Soccer3_Greek_League": "Greek League",
    "Soccer_Super_League": "Super League",
    "Soccer_World_Cup": "Wereldbeker",
    "Soccer_Soccer3_World_Cup": "Wereldbeker",
    "Soccer": "Voetbal",
    "US Football": "American football",
    "Marble_Racing_Marbles": "Knikkers",
    "Marble_Racing_Marbles2": "Zand",
    "Marble_Racing_Marbles_Euro": "Soccer",
    "Marble_Racing_Marbles_Halloween": "Halloween",
    "Basketball_US1": "US",
    "Basketball_US2": "US2",
    "Basketball_Europe": "Europa",
    "Horses_Sprints": "Sprints",
    "Horses_Flats": "Flats",
    "Horses_Jumps": "Sprongen",
    "Dogs_Flats": "Flats",
    "Dogs_City": "Statische kansen",
    "Motor_Racing_Stock_Cars": "Voorraad auto's",
    "Motor_Racing_Indy_Cars": "Indy-auto's",
    "US_Football_NFLA": "NFLA",
    "US_Football_NFL": "NFL",
    "Matchday_English_Matchday_English": "Speeldag",
    "Matchday_Turkish_Matchday_Turkish": "Speeldag",
    "Matchday_Greek_Matchday_Greek": "Speeldag",
    "FORECAST": "Forecast",
    "TRICAST": "Tricast",
    "REVERSE_FORECAST": "Combinatie Forecast",
    "REVERSE_TRICAST": "Combinatie Tricast",
    "FIRST_ST": "1",
    "SECOND_ND": "2",
    "THIRD_RD": "3",
    "RD": "de",
    "ST": "ste",
    "ND": "de",
    "ANY": "Eender welk",
    "TO_WIN": "Wint",
    "RACE_CARD": "RACECARD",
    "EACH_WAY": "Elke kant",
    "EW": "E/W",
    "FORECAST_TRICAST": "Forecast/Tricast",
    "EACH_WAY_ODDS_PLACE": "E/W {0} 1-2",
    "EACH_WAY_ODDS_SHOW": "E/W {0} 1-2-3",
    "EXPAND_ALL": "Expand Markets",
    "COLLAPSE_ALL": "Collapse Markets",
    "NUMBER": "Nummer",
    "SORT_BY": "Sorteer op",
    "BET_SLIP": "Bet Slip",
    "CLOSE_BET_SLIP": "Sluiten",
    "CLOSE_SLIP": "Sluiten",
    "PLACED_BETS": "Geplaatst",
    "SETTLED_BETS": "Afgehandeld",
    "SLIP": "Slip",
    "OPEN_BETS": "Openstaand",
    "CLEAR_SELECTIONS": "Selecties wissen",
    "ADD_TO_BET_SLIP": "Aan Bet Slip toevoegen",
    "NO_BETS": "Geen Bets",
    "COMBINATION_TRICAST": "Combinatie Tricast",
    "COMBINATION_FORECAST": "Combinatie Forecast",
    "TOTAL_STAKE": "Totale inzet",
    "TOTAL_POTENTIAL_RETURNS": "Potentiële uitbetaling",
    "N_A": "N/A",
    "PLACE_BETS": "Plaats weddenschappen",
    "REMOVE_ALL": "Verwijder ze allemaal",
    "POT_RETURNS": "Pot. uitbetaling",
    "RETURNED": "Uitbetaald",
    "REFUNDED": "Terugbetaald",
    "OK": "OK",
    "WIN_INITIAL": "W",
    "DRAW_INITIAL": "D",
    "LOSE_INITIAL": "L",
    "SETTINGS": "Instellingen",
    "LANGUAGE": "Taal",
    "LAYOUT": "Layout",
    "ODDS": "Odds",
    "EN_GB": "English UK",
    "DECIMAL": "Decimaal",
    "FRACTIONAL": "Fractioneel",
    "AMERICAN": "Amerikaans",
    "SIMPLIFIED_DESKTOP": "This is The main class for the desktop simplified UI",
    "SIMPLIFIED_MOBILE": "This is The main class for the mobile simplified UI",
    "SHOW_VIDEO": "Show Video",
    "ALERT_NOTIFICATION": "Alert",
    "WARNING_NOTIFICATION": "Waarschuwing",
    "WARNING_NOTIFICATION_REALITY_CHECK": "Waarschuwing",
    "INFO_NOTIFICATION": "INFORMATIE",
    "SUCCESS_NOTIFICATION": "Succes",
    "SELECTION_REMOVAL": "Deze selectie wordt verwijderd in ",
    "SECONDS": " seconden",
    "SECOND": " seconde",
    "REMOVE_CLOSED_EVENTS": "Afgelopen events verwijderen",
    "SET_VIDEO_ON_FUL_SCREEN": "Set Video on Full Screen?",
    "CANCEL": "Annuleren",
    "INTERNAL_ERROR": "Interne fout",
    "OPEN_BETS_WARNING": "Sommige of alle openstaande weddenschappen konden niet aan de wedstrijdkaart worden toegevoegd omdat ze horen bij afgelopen evenementen.",
    "-32602": "Een of meerdere bets werden niet op tijd geplaatst.",
    "OPEN_BETS_ON_BET_SLIP_LIMIT_REACHED": "Het maximum aantal weddenschappen op het slip bet tabblad werd bereikt. Gelieve weddenschappen te plaatsen of te verwijderen vooraleer je er nieuwe toevoegt.",
    "-20000": "Verbinding kan niet worden gemaakt (Foutcode: -20000)",
    "-20001": "Verbinding kan niet worden gemaakt (Foutcode: -20001)",
    "-20002": "Te veel verzoeken (Foutcode: -20002)",
    "-20003": "Te veel verzoeken (Foutcode: -20003)",
    "-20004": "Ongeldig verzoek (Error Code: -20004)",
    "-10000": "Ongeldig verzoek (Error Code: -10000)",
    "-10001": "Ongeldig verzoek (Error Code: -10001)",
    "-1000": "Het spel werd opgeschort. Gelieve onze klantenservice te contacteren.",
    "-999": "De sessie is verlopen.",
    "-998": "De speler is geschorst",
    "-997": "Niet toegestane verzoek",
    "-996": "Fout bij het verwerken van het verzoek (Foutcode: -996)",
    "-995": "Fout bij het verwerken van het verzoek (Foutcode: -995)",
    "-994": "De verbinding met de server is verbroken, de weddenschap werd niet geplaatst.",
    "-980": "Fout bij het verwerken van het verzoek (Foutcode: -980)",
    "-979": "Fout bij het verwerken van het verzoek (Foutcode: -979)",
    "-978": "Er is te weinig geld beschikbaar om deze transactie uit te voeren.",
    "-977": "De realiteitscontrole is mislukt.",
    "-976": "De portefeuille-transactie is tijdelijk geblokkeerd.",
    "-975": "De inzetlimiet is overschreden.",
    "-974": "De verlieslimiet is overschreden.",
    "-973": "Geen limiet gesteld.",
    "-972": "Fout ivm verantwoord gokken.",
    "-971": "De portefeuille-transactie is mislukt.",
    "-970": "De portefeuille-transactie is afgewezen.",
    "-969": "Portefeuille-communicatie fout.",
    "-968": "Portefeuille-transactie fout.",
    "-967": "De authenticatie is mislukt.",
    "-966": "Het hoge winst-plafond is overschreden.",
    "-965": "Onjuiste parameters doorgegeven.",
    "BET_STAKE_OUT_OF_LIMITS_MESSAGE": "Een of meerdere inzetten zijn niet geldig. Min inzet: {0}, Max inzet: {1}. Gelieve dit op te lossen vooraleer je je weddenschappen plaatst.",
    "LIST_BET_STAKE_OUT_OF_LIMITS_MESSAGE": 'Stake limits on {0} are Min {1} & Max {2}',
    "BET_POTENTIAL_RETURNS_OUT_OF_LIMITS_MESSAGE": "Een of meerdere potentiële uitbetalingen overschrijden de max uitbetaling van {0}. Gelieve dit op te lossen vooraleer je je weddenschappen plaatst.",
    "BET_NON_DIVISIBLE_MESSAGE": "Een of meerdere weddenschappen zijn niet deelbaar door {0}. Gelieve dit op te lossen vooraleer je je weddenschappen plaatst.",
    "SINGLE_BET_COMMIT_MESSAGE": "Het is niet mogelijk om meerdere single weddenschappen te plaatsen",
    "REALITY_CHECK_WARNING_MESSAGE_LINE_1": "De weddenschap(pen) die je plaatst zijn hoger dan {0}.",
    "MIN_STAKE_REALITY_CHECK_WARNING_MESSAGE_LINE_1": 'The bet(s) you are placing are under {0}',
    "REALITY_CHECK_WARNING_MESSAGE_LINE_2": "Is dit OK",
    "REALITY_CHECK_TOTAL_STAKE_SINGLE_EVENT_WARNING": "Het maximumbedrag van {0} werd ingezet. Gelieve een ander event te selecteren",

    //SIMPLIFIED UI
    "TOTAL_BETS": "TOTALE WEDDENSCHAP",
    "PLACE_YOUR_BETS": "Plaats je weddenschappen",
    "RACE_START": "Start van de race",
    "RACE_START_TIME": "Starttijd",
    "BET_SUMMARY": "Betoverzicht",
    "NO_BETS_RESUME": "Er werden geen weddenschappen gemaakt voor het huidige event",
    "LIVE": "LIVE",
    "RACERS": "Racers",
    "SELECTION": "Selectie",
    "DATE_LOCATION": "Event",
    "STAKE": "Inzet",
    "BET_TYPE_STAKE": "Bettype / Inzet",
    "POTENTIAL_RETURNS": "Pot. uitbetaling",
    "BET_HISTORY": "Wedgeschiedenis",
    "BET_HISTORY_LABEL": "Klik op de knop Wedgeschiedenis om verder te gaan in het verleden",
    "FILTER_WINS": "Filter winsten",
    "NEXT_RACE": "Volgende race",
    "WIN": "Winst",
    "PLACE": "Plaats",
    "SHOW": "Toon",
    "EXACTA": "Forecast",
    "TRIFECTA": "Tricast",
    "NO_WIN": "GEEN WINST",
    "WON": "GEWONNEN",
    "LOST": "VERLOREN",
    "CURRENT_RACE": "Huidige race",
    "BOX": "BOX",
    "TO": "naar",
    "PAYS": "betaalt",
    "TRIFECTA_BOX": "Combinatie Tricast",
    "EXACTA_BOX": "Combinatie Forecast",
    "FINISH_YOUR_BETS": "Werk je weddenschappen af",
    "SELECT_YOUR_BET_BELOW": "Selecteer je weddenschap",
    "BET": "wed",
    "REMOVED": "verwijderd",
    "RESULT": "Resultaat",
    "GOALS": "Doelpunten",
    "NO_MORE_BETS": "Geen weddenschappen meer",
    "EVENT_LIVE_MSG_LINE_1": "Huidig event live",
    "EVENT_LIVE_MSG_LINE_2": "Selecteer in de toekomst",
    "EVENT_LIVE_MSG_LINE_3": "Events bovenaan",
    "NO_FUTURE_EVENTS": "Geen events in de toekomst",
    "AUTHENTICATION_REQUIRED": "Gelieve aan te melden om verder te gaan",
    "GAME_DISABLED": "Game uitgeschakeld",
    "GAME_DISABLED_MESSAGE": "Gelieve onze klantenservice te contacteren",
    "VOIDED": "ONGELDIG",
    "HELP": "Hulp",
    "LAST_RESULTS": "Laatste resultaten",
    "NO_LAST_RESULTS": "Geen laatste resultaten",
    "PREVIOUS_RESULTS": "Vorige resultaten",
    "OFFENSE_PREVIOUS_RESULTS": "Offence Vorige resultaten",
    "DEFENSE_PREVIOUS_RESULTS": "Defence Vorige resultaten",
    "NO_LUCK": "GEEN GELUK",
    "THIS_TIME": "DEZE KEER",
    "LOOK_FOR_THE_NEXT": "Zoek naar het volgende",
    "SCHEDULED_EVENT": "geplande event",
    "LOOK_FOR_THE": "Zoek naar",
    "NEXT_SCHEDULED": "het volgende geplande",
    "EVENT": "event",
    "RETURNS": "UITBETALINGEN",
    "NEXT": "Volgende",
    "FUTURE": "Toekomstige",
    "PLAYING": "Spelend",

    "ON": "op",
    "MB_RACE_ON": "op",
    "MB_RACE_WIN": "Wint",
    "MB_RACE_PLACE": "Plaats",
    "MB_RACE_SHOW": "Toon",
    "MB_RACE_TRIFECTA_BOX": "Combinatie Tricast",
    "MB_RACE_EXACTA_BOX": "Combinatie Forecast",
    "MB_RACE_EXACTA": "forecast",
    "MB_RACE_TRIFECTA": "tricast",
    "MB_FOOTBALL_ON": "op",
    "ADVERTISING_SPACE": "ADVERTISING SPACE",
    "CLEAR_LAST": "Wis de laatste",
    "CLEAR_ALL": "Wis ze allemaal",
    "ACTIVE_BETS": "Actieve weddenschappen",
    "ONLY_SHOW_WINS": "Toon alleen de winsten",
    "MORE": "Meer",
    "BETS": "Weddenschappen",
    "LOADING": "Aan het laden",
    "BET_SELECTION_MESSAGE": "Maak je selectie(s) door op de odds te klikken.",
    "SIMPLE": "simple",
    "EXOTIC": "exotic",
    "UNDO": "ongedaan maken",
    "CLEAR": "wissen",
    "HISTORY": "geschiedenis",
    "MARKETS": "Markten",
    "MAIN": "Voornaamste",
    "VS": "vs",
    "AT": "@",
    "SCORE": "score",
    "DEFENDS": "@",
    "ATTACKS": "score",
    "DETAILS": "Details",
    "NO_GOALS": "Geen goals",
    "MAX_WINNINGS_REACHED": "Hoogste winst bereikt",
    "MAX_WINNINGS_REACHED_TEXT": "De huidige weddenschap zal de max uitbetaling van {0} overschrijden. De max toegestane inzet voor deze weddenschap is {1}.",
    "NO_CONNECTION_TITLE": "Verbinding verbroken",
    "NO_CONNECTION_TITLE_TEXT": "Verbinding met server verbroken, zorg ervoor dat je over een stabiele netwerkverbinding beschikt en vernieuw de pagina. Als het probleem aanhoudt contacteer je best onze klantendienst.",
    "PLAYER_LOGGED_OTHER_PLACE_TITLE_TEXT": "Verbinding verbroken, de gebruiker is tweemaal verbonden.",
    "BET_CONFIRMED_TEXT": "none",
    "TAX_NOTIFICATION_TEXT": "none",
    "THE MANOR GROUND": "Berners Stadium",
    "METRO STADIUM": "Metro Stadium",
    "HorsesSprints": "Wetmore Sprints",
    "Showell Park": "Showell Park",
    "2FurlongHorses": "Wetmore Sprints",
    "Sandringham Flats": "Sandringham Flats",
    "Princess Parkway": "Princess Parkway",
    "Virtual Arena": "Virtual Arena",
    "Inspired Arena": "Inspired Arena",
    "HorsesJumps": "Inspired Downs",
    "DogFlat": "Barking Green",
    "Dogs2": "Barking Green",
    "Victoria Park": "Victoria Park",
    "Jennison Stadium": "Jennison Stadium",
    "Circuit": "Circuit",
    "Speedway Park": "Inspired Raceway",
    "Auto Raceway": "Auto Raceway",
    "NO_CONNECTION_TO_VIRGO": "De verbinding was weggevallen",
    "NO_CONNECTION_TO_VIRGO_TEXT": "Gelieve de pagina te vernieuwen en aan te melden.",
    "BROWSER_NOT_SUPPORTED_DETAILS": "Je huidige browser is niet ondersteund. Gebruik een van de volgende browsers: Chrome, Firefox of Safari.",
    "BROWSER_NOT_SUPPORTED": "Browser niet ondersteund",
    "DOWNLOAD_CHROME": "Donwload Chrome",
    "DOWNLOAD_FIREFOX": "Donwload Firefox",
    "v": "V",
    "1": "1",
    "x": "x",
    "2": "2",
    "at": "@",
    "+10.5": "+10.5",
    "+15.5": "+15.5",
    "+5.5": "+5.5",
    "-10.5": "-10.5",
    "-15.5": "-15.5",
    "-5.5": "-5.5",
    "Over 219.5": "Meer dan 219.5",
    "Under 219.5": "Minder dan 219.5",
    "Over 214.5": "Meer dan 214.5",
    "Under 214.5": "Minder dan 214.5",
    "Over 209.5": "Meer dan 209.5",
    "Under 209.5": "Minder dan 209.5",
    "Over 144.5": "Meer dan 144.5",
    "Under 144.5": "Minder dan 144.5",
    "Over 149.5": "Meer dan 149.5",
    "Under 149.5": "Minder dan 149.5",
    "Over 154.5": "Meer dan 154.5",
    "Under 154.5": "Minder dan 154.5",
    "Over 159.5": "Meer dan 159.5",
    "Under 159.5": "Minder dan 159.5",
    "Over 164.5": "Meer dan 164.5",
    "Under 164.5": "Minder dan 164.5",
    "Marble Racing": "Knikkerrace",
    "Rolling Downs": "Rolling Downs",
    "FINISHING_ORDER": "Volgorde van aankomst",
    "FORECAST_MARBLE": "Top 2",
    "TRICAST_MARBLE": "Top 3",
    "REVERSE_FORECAST_MARBLE": "Top 2 eender welke volgorde",
    "REVERSE_TRICAST_MARBLE": "Top 3 eender welke volgorde",
    "TO_WIN_MARBLE": "Winst",
    "PLACE_MARBLE": "Plaats",
    "SHOW_MARBLE": "Toon",
    "MARBLE": "Knikkers",
    "Rumble Turns": "Rumble Turns",
    "Maple Downs": "Maple Downs",
    "BALANCE": "Balans",
    "DATE_FORMAT": "DD/MM/YYYY HH:mm",
    "WINS_THE_GAME": "Wint de game",
    "Any": "Eender welk",
    "BET_BOTH": "Wed op beide",
    "Matchday_English": "Speeldag",
    "Matchday_Turkish": "Speeldag",
    "Matchday_Greek": "Speeldag",
    "betSlip_Matchday_English": "Speeldag Engels",
    "betSlip_Matchday_Turkish": "Speeldag Turks",
    "betSlip_Matchday_Greek": "Speeldag Grieks",
    "betSlip_Soccer": "Voetbal",
    "betSlip_Horses": "Paarden",
    "betSlip_Basketball": "Basketbal",
    "betSlip_Dogs": "Honden",
    "betSlip_Motor Racing": "Motorracen",
    "betSlip_US Football": "American football",
    "betSlip_Marble Racing": "Knikkerrace",
    "POS": "pos",
    "TEAM": "team",
    "P": "p",
    "W": "w",
    "D": "d",
    "L": "l",
    "F": "f",
    "A": "a",
    "PTS": "ptn",
    "LEAGUE TABLE": "ranglijst",
    "TREND": "trend",
    "Matchday_Islington": "ISL",
    "Matchday_City": "CTY",
    "Matchday_Palace": "PAL",
    "Matchday_Chelsea": "CHE",
    "Matchday_Southampton": "SOU",
    "Matchday_Wolverhampton": "WOL",
    "Matchday_Sheffield": "SHE",
    "Matchday_Leicester": "LEI",
    "Matchday_Newcastle": "NEW",
    "Matchday_Tottenham": "TOT",
    "Matchday_West Ham": "WHA",
    "Matchday_United": "UTD",
    "Matchday_Leeds": "LEE",
    "Matchday_Liverpool": "LIV",
    "Matchday_Everton": "EVE",
    "Matchday_Aston": "AST",
    "Matchday_Basaksehir": "BAS",
    "Matchday_Trabzon": "TRZ",
    "Matchday_Besiktas": "BKS",
    "Matchday_Sivas": "SIV",
    "Matchday_Alanya": "ALA",
    "Matchday_Galata": "GLS",
    "Matchday_Fenerbahce": "FRB",
    "Matchday_Gazientep": "GAZ",
    "Matchday_Antalya": "ANT",
    "Matchday_Kasimpasa": "KAS",
    "Matchday_Goztepe": "GOZ",
    "Matchday_Gencler": "ESK",
    "Matchday_Konya": "BUR",
    "Matchday_Rize": "RIZ",
    "Matchday_Malatya": "MAL",
    "Matchday_Kayseri": "KAY",
    "Matchday_Dikefalos Vora": "ΔΙΚ",
    "Matchday_Erithrolefkoi": "ΘΡΥ",
    "Matchday_Enosi": "ΕΝΩ",
    "Matchday_Peristeri": "ΠΕΡ",
    "Matchday_Prasinoi": "ΠΡΑ",
    "Matchday_Kitrinoi Vora": "ΚΙΤ",
    "Matchday_Nea Smirni": "ΣΜΥ",
    "Matchday_Xanthi": "ΞΑΝ",
    "Matchday_Tripoli": "ΤΡΙ",
    "Matchday_Agrinio": "ΑΓΡ",
    "Matchday_Larisa": "ΛΑΡ",
    "Matchday_Lamia": "ΛΑΜ",
    "Matchday_Ioannina": "ΙΩΑ",
    "Matchday_Iraklio": "ΗΡΑ",
    "Matchday_A.O. Rizoupolis": "ΡΙΖ",
    "Matchday_Volos": "ΒΟΛ",
//Soccer3 Greek Teams
    "Dikefalos Vora": "ΔΙΚ",
    "Erithrolefkoi": "ΘΡΥ",
    "Enosi": "ΕΝΩ",
    "Peristeri": "ΠΕΡ",
    "Prasinoi": "ΠΡΑ",
    "Kitrinoi Vora": "ΚΙΤ",
    "Nea Smirni": "ΣΜΥ",
    "Xanthi": "ΞΑΝ",
    "Tripoli": "ΤΡΙ",
    "Agrinio": "ΑΓΡ",
    "Larisa": "ΛΑΡ",
    "Lamia": "ΛΑΜ",
    "Ioannina": "ΙΩΑ",
    "Iraklio": "ΗΡΑ",
    "A.O. Rizoupolis": "ΡΙΖ",
    "Volos": "ΒΟΛ",
    "Dortmund": "Dortmund",
    "Chelsea": "Chelsea",
    "Porto": "Porto",
    "Rome": "Rome",
    "Benfica": "Benfica",
    "Celtic": "Celtic",
    "United": "United",
    "UNDER_OVER_MATCHDAY": "Meer dan/Minder dan",
    "UNDER_OVER_05_SHORT": "0.5",
    "UNDER_OVER_15_SHORT": "1.5",
    "UNDER_OVER_25_SHORT": "2.5",
    "UNDER_OVER_35_SHORT": "3.5",
    "UNDER_SHORT": " U",
    "OVER_SHORT": " O",
    "FULL TIME": " FULL TIME",
    "FT": " FT",
    "System": "SYSTEEM",
    "x1": "(x1)",
    "Multiplier": "Bet herhalen",
    "Main markets": "Belangrijkste markten",
    "4RANDOM": "4 RANDOM",
    "6RANDOM": "6 RANDOM",
    "8RANDOM": "8 Random",
    "8FAVS": "8 FAVS",
    "QUICK_SELECT": "SNELLE SELECTIE",
    "UNDER": "Minder dan",
    "OVER": "Meer dan",
    "UNDER_OVER_2_5": "Meer dan/Minder dan 2.5",
    "UNDER_OVER_3_5": "Meer dan/Minder dan 3.5",
    "MATCH_RESULT": "MATCHRESULTAAT",
    "YES": "JA",
    "NO": "NEEN",
    "REALITY_CHECK_WARNING_YES": "Ja",
    "REALITY_CHECK_WARNING_NO": "Neen",
    "ACCUMULATOR": "Accumulator",
    "+1G": "+1G",
    "Single": " Single",
    "Doubles": "Dubbele",
    "Trebles": "Drievoudige",
    "Four Folds": "Viervoudige",
    "Five Folds": "Vijfvoudige",
    "Six Folds": "Zesvoudige",
    "Seven Folds": "Zevenvoudige",
    "Eight Folds": "Achtvoudige",
    "MD": "MD{0}",
    "MATCH": "MATCH",
    "INVALID_ACCA": "Waar selecties gemarkeerd verschijnen, zijn je meervoudige selecties beperkt",
    "INVALID_ODDS": "De waarde van de odds is te hoog. Gelieve je selecties aan te passen",
    "INVALID_ACCA_MORETHAN_8": "Meervoudige weddenschappen kunnen maximum 8 selecties van eenzelfde wedstrijd bevatten",
    "ACCUMULATOR_BOOST": "Accumulator Boost",
    "Bonus_Info": "  {0}% Bonus",
    "+": " +",
    "Bonus_Value": "Incl {0} Bonus",
    "ACCUMULATOR_INFO": "Als je Accumulator-weddenschap succesvol is, wordt een bonus van {0}% - {1}% aan je uitbetaling toegevoegd. Het bedrag van de bonus is afhankelijk van het aantal selecties.",
    "BET_TYPE": "Bettype",
    "BOOST": "Boost",
    "BOOST_PERCENTAGE": "{0}%",
    "BOOST_BONUS_START": "{0} of meer accumulator-selecties ontvangen een bonus",
    "BOOST_BONUS_UPGRADE": "Voeg een andere accumulator-selectie toe om een extra bonus te krijgen",
    "BOOST_BONUS_MAX": "Je hebt de maximum accumulator-bonus bereikt",
    "Marbles_Euro_1": "Belgium",
    "Marbles_Euro_2": "Croatia",
    "Marbles_Euro_3": "Denmark",
    "Marbles_Euro_4": "England",
    "Marbles_Euro_5": "France",
    "Marbles_Euro_6": "Germany",
    "Marbles_Euro_7": "Italy",
    "Marbles_Euro_8": "Netherlands",
    "Marbles_Euro_9": "Portugal",
    "Marbles_Euro_10": "Spain",
    "Short_Over": "Meer dan {0}",
    "Short_Under": "Minder dan {0}",
    "DEMOPLAY_NOTIFICATION_MESSAGE_LINE_1": "Please register or log in to place a bet",
    "DEMOPLAY_NOTIFICATION_MESSAGE_LINE_2": " ",
    "DEMOPLAY_NOTIFICATION_DISMISS": "Dismiss",
    "DEMOPLAY_NOTIFICATION_OK": "OK",
    "Matchday_Moroccan": "Journée",
    "Matchday_Moroccan_Matchday_Moroccan": "Journée",
    "betSlip_Matchday_Moroccan": "Journée",

    //Matchday Moroccan Teams
    "Matchday_Casa Reds": "WYD",
    "Matchday_Casa Greens": "RAJ",
    "Matchday_Fès": "FES",
    "Matchday_El Jadida": "ELJ",
    "Matchday_Berkane": "BKN",
    "Matchday_Feth": "FTH",
    "Matchday_FARabat": "FAR",
    "Matchday_Mohammedia": "MOH",
    "Matchday_Soualem": "SLM",
    "Matchday_Khouribga": "KHO",
    "Matchday_Tanger": "TAN",
    "Matchday_Agadir": "AGA",
    "Matchday_Berrechid": "BER",
    "Matchday_Oujda": "OUJ",
    "Matchday_Safi": "SAF",
    "Matchday_Oued Zem": "ODZ",
    "Matchday_Tétouan": "TET",
    "Matchday_Touarga": "TRG",
    "Matchday_Beni Mellal": "BNM",
    "Matchday_Stade Maroc": "STM",
    "Matchday_Zemamra": "ZMR",

    "Soccer_Soccer3_Moroccan_League": "Moroccan",
    //Soccer3 Moroccan Teams
    "Casa Reds": "Casa Reds",
    "Casa Greens": "Casa Greens",
    "Fès": "Fès",
    "El Jadida": "El Jadida",
    "Berkane": "Berkane",
    "Feth": "Feth",
    "FARabat": "FARabat",
    "Mohammedia": "Mohammedia",
    "Soualem": "Soualem",
    "Khouribga": "Khouribga",
    "Tanger": "Tanger",
    "Agadir": "Agadir",
    "Berrechid": "Berrechid",
    "Oujda": "Oujda",
    "Safi": "Safi",
    "Oued Zem": "Oued Zem",
    "Tétouan": "Tétouan",
    "Touarga": "Touarga",
    "Beni Mellal": "Beni Mellal",
    "Stade Maroc": "Stade Maroc",
    "Zemamra": "Zemamra",
    "QUICK_FILL": "Quick Fill",
    "MAD" : "{0} MAD",

    //Matchday Belgium
    "Matchday_Belgium": "Speeldag",
    "Matchday_Belgium_Matchday_Belgium": "Speeldag",
    "betSlip_Matchday_Belgium": "Speeldag België",
    //Matchday Belgium Teams
    "Matchday_Saint-Gilles": "SAI",
    "Matchday_Club": "CLU",
    "Matchday_Anderlecht": "AND",
    "Matchday_Antwerp": "ANT",
    "Matchday_Gent": "GEN",
    "Matchday_Mechelen": "MEC",
    "Matchday_Charleroi": "CHA",
    "Matchday_Genk": "GNK",
    "Matchday_Brugge": "BRU",
    "Matchday_Sint-Truiden": "SIN",
    "Matchday_Leuven": "LEU",
    "Matchday_Kortrijk": "KOR",
    "Matchday_Liege": "LIE",
    "Matchday_Oostende": "OOS",
    "Matchday_Waregem": "WAR",
    "Matchday_Eupen": "EUP",
    "Matchday_Seraing": "SER",

    //BonusBet
    "Gift_for_You_Heading" :"A GIFT FOR YOU",
    "Gift_for_You_Content": "Congratulations! You have promotional offers to redeem.",
    "View_Offers" : "VIEW OFFERS",
    "Do_Not_Show_MSG": "DO NOT SHOW AGAIN",
    "MY_OFFERS" : 'MY OFFERS',
    "SELECT_OFFER" : 'SELECT YOUR OFFER',
    "NO_OFFER" : 'THERE ARE NO ACTIVE OFFERS',
    "CHOOSE_BET": 'CHOOSE BET',
    "Opt_In": 'OPT IN',
    "Key_Terms_Heading" :"KEY TERMS",
    "No_Thanks" : "NO THANKS",
    "PROMO_BET": 'PROMO BET',
    "Time_To_Bet": "TIME TO BET",
    "OPTED_IN_MSG": "THANKS, YOU HAVE OPTED IN",
    "EXP": "Exp.",
    "SELECT": "Select",
    "DEMO_SITE_PROMO_NOT_AVAILABLE": "This demo site does not currently offer any promos. Please log in/register to access current offers. !",
    "Horses_US_Horses": "USA",

    //cricket
    "Cricket" : "Cricket",
    "Cricket_International": "Internationaal",
    "betSlip_Cricket": "Cricket",
    //circket teams
     "Australia":"Australia",
     "India":"India",
     "Pakistan":"Pakistan",
     "West Indies" : "West Indies",
     "Sri Lanka":"Sri Lanka",
     "New Zealand":"New Zealand",
     "South Africa":"South Africa",
     "Australia_short":"AUS",
     "WestIndies_short" : "WI",
     "SriLanka_short":"SRI",
     "NewZealand_short":"NZL",
     "India_short":"IND",
     "SouthAfrica_short":"RSA",
     "Pakistan_short":"PAK",
     "England_short": "ENG",
     "Tie":"Tie",
    //cricket markets
     "MATCH_WINNER":"Matchwinnaar",
     "TOTAL_SIXES_IN_MATCH":"Totale match 6's",
     "TOTAL_SIXES_IN_MATCH_SHORT": "Minder dan 1.5",
     "TOTAL_FOUR_IN_MATCH":"Totale match 4's",
     "TOTAL_BOUNDARIES_IN_MATCH":"Totale match boundaries",
     "FIRST_TEAM_TOTAL_RUNS":"{0} Totale runs",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL":"{0} Runs van eerste bal",
     "FIRST_TEAM_WICKET_LOST":"{0} Wicket verloren",
     "FIRST_TEAM_WICKET_LOST_DISMISSAL_TYPE": "{0} Eerste methode van dismissal type",
     "FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05_SHORT": "0.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15_SHORT": "1.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25_SHORT": "2.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35_SHORT": "3.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_UNDER_OVER":"{0} Runs van eerste bal over/onder",
     "FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05": "{0} Runs van eerste bal over/onder",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15": "{0} Runs van eerste bal over/onder",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25": "{0} Runs van eerste bal over/onder",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35": "{0} Runs van eerste bal over/onder",
     "Caught" : "Gevangen",
     "Bowled":"Gebowld",
     "LBW":"LBW",
     "No Wicket":"Geen wicket",
     "OverZeroPointFive": "Meer dan 0.5",
     "UnderZeroPointFive": "Minder dan 0.5",
     "OverOnePointFive": "Meer dan 1.5",
     "UnderOnePointFive": "Minder dan 1.5",
     "OverTwoPointFive": "Meer dan 2.5",
     "UnderTwoPointFive": "Minder dan 2.5",
     "OverThreePointFive": "Meer dan 3.5",
     "UnderThreePointFive": "Minder dan 3.5",
     "Yes": "Yes",
     "No":"No",
     "FINAL_SCORE":"Final Score",
     OVER_145: 'Meer dan 14.5',
     UNDER_145: 'Minder dan 14.5',
     DRAW_Cricket: "DRAW",
      //TENNIS
    TOTAL_POINTS:"Totale aantal punten",
    HANDICAP_TENNIS: "Handicap",
    Scotland :"Scotland",
    USA: "USA",
    Tennis_International: "International",
    betSlip_Tennis: "Tennis",
    "Win By 2 or 3": "Gewonnen met drie punten verschil of minder",
    "Win By 4 or 5": "Gewonnen met vier of vijf punten verschil",
    "Win By 6 or 7": "Gewonnen met zes of zeven punten verschil",
    "Tennis": "Tennis",
   //baseball
    WINNER : "WINNAAR",
    TOTAL_HOME_RUNS_UNDER_OVER: "TOTALE AANTAL HOMERUNS O/U",
    TOTAL_HOME_RUNS:  "EXACTE AANTAL HOMERUNS",
    WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER:"WINNAAR & TOTALE AANTAL HOMERUNS O/U 5.5",
    WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER_SHORT:"Winnaar & Totale aantal homeruns O/U 5.5",
    BATTER1_HOME_RUNS: "{0} HOMERUNS",
    BATTER2_HOME_RUNS: "{1} HOMERUNS",
    Baseball_HR_ShootOut_Legends: "Homeruns Shootout Legends",
    Baseball_HR_ShootOut_Legends_SHORT: "Homerun Shootout",
    "Baseball": "Honkbal",
    "betSlip_Baseball": "Honkbal",
    "Player 1 AND OVER_5_5":"{0} & Meer dan 5.5",
    "Player 2 AND OVER_5_5":"{0} & Meer dan 5.5",
    "Player 1 AND UNDER_5_5":"{0} & Minder dan 5.5",
    "Player 2 AND UNDER_5_5":"{0} & Minder dan 5.5",
    "Draw AND OVER_5_5":"Gelijk spel & meer dan 5.5",
    "Draw AND UNDER_5_5":"Gelijk spel & minder dan 5.5",
    "HOME RUNS":"{0} HOMERUNS",
    "Next Fixtures":"Next Fixtures",
    "MATCH_IN_PROGRESS": "Match In Progress",
    "Matchday_Light_English": "Matchday Light",
    "Matchday_Light_English_Matchday_Light_English": "English League",
    "betSlip_Matchday_Light_English": "Matchday Light",
    //NFL
    'Cardinals' : 'Cardinals',
    'Falcons' : 'Falcons',
    'Ravens' : 'Ravens',
    'Bills' : 'Bills',
    'Panthers' : 'Panthers',
    'Bears' : 'Bears',
    'Bengals' : 'Bengals',
    'Browns' : 'Browns',
    'Cowboys' : 'Cowboys',
    'Broncos' : 'Broncos',
    'Lions' : 'Lions',
    'Packers' : 'Packers',
    'Texans' : 'Texans',
    'Colts' : 'Colts',
    'Jaguars' : 'Jaguars',
    'Chiefs' : 'Chiefs',
    'Raiders' : 'Raiders',
    'Chargers' : 'Chargers',
    'Rams' : 'Rams',
    'Dolphins' : 'Dolphins',
    'Vikings' : 'Vikings',
    'Patriots' : 'Patriots',
    'Saints' : 'Saints',
    'Giants' : 'Giants',
    'Jets' : 'Jets',
    'Eagles' : 'Eagles',
    'Steelers' : 'Steelers',
    '49ers' : '49ers',
    'Seahawks' : 'Seahawks',
    'Buccaneers' : 'Buccaneers',
    'Titans' : 'Titans',
    'Commanders' : 'Commanders',
    'NEW' : 'New',
    //Soccer_Soccer3_Turkish_League team names and game name
    "Soccer_Soccer3_Turkish_League": "Turkish League",
    "Basaksehir": "BAS",
    "Trabzon": "TRZ",
    "Besiktas": "BKS",
    "Sivas": "SIV",
    "Alanya": "ALA",
    "Galata": "GLS",
    "Fenerbahce": "FRB",
    "Gazientep": "GAZ",
    "Antalya": "ANT",
    "Kasimpasa": "KAS",
    "Goztepe": "GOZ",
    "Gencler": "ESK",
    "Konya": "BUR",
    "Rize": "RIZ",
    "Malatya": "MAL",
    "Kayseri": "KAY",

    //NBA 
  "Basketball_NBA": "NBA",
  "Atlanta Hawks": "Atlanta Hawks",
  "Boston Celtics": "Boston Celtics",
  "Brooklyn Nets": "Brooklyn Nets",
  "Charlotte Hornets": "Charlotte Hornets",
  "Chicago Bulls": "Chicago Bulls",
  "Cleveland Cavaliers": "Cleveland Cavaliers",
  "Dallas Mavericks": "Dallas Mavericks",
  "Denver Nuggets": "Denver Nuggets",
  "Detroit Pistons": "Detroit Pistons",
  "Golden State Warriors": "Golden State Warriors",
  "Houston Rockets": "Houston Rockets",
  "Indiana Pacers": "Indiana Pacers",
  "Los Angeles Clippers": "Los Angeles Clippers",
  "Los Angeles Lakers": "Los Angeles Lakers",
  "Memphis Grizzlies": "Memphis Grizzlies",
  "Miami Heat": "Miami Heat",
  "Milwaukee Bucks": "Milwaukee Bucks",
  "Minnesota Timberwolves": "Minnesota Timberwolves",
  "New Orleans Pelicans": "New Orleans Pelicans",
  "New York Knicks": "New York Knicks",
  "Oklahoma City Thunder": "Oklahoma City Thunder",
  "Orlando Magic": "Orlando Magic",
  "Philadelphia 76ers": "Philadelphia 76ers",
  "Phoenix Suns": "Phoenix Suns",
  "Portland Trail Blazers": "Portland Trail Blazers",
  "Sacramento Kings": "Sacramento Kings",
  "San Antonio Spurs": "San Antonio Spurs",
  "Toronto Raptors": "Toronto Raptors",
  "Utah Jazz": "Utah Jazz",
  "Washington Wizards": "Washington Wizards",
  "TOTALPOINTS": "TOTAL POINTS"

}


// WEBPACK FOOTER //
// ./src/localization/nl_BE.js